import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import StatusBadge from '../../../common/helpers/StatusBadge'
import WithAjax from "../../../common/helpers/WithAjax";
import WithNotify from '../../../common/helpers/WithNotify'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import EditForm from '../../../../pages/EditForm'
import Select from '../../../common/form/Select'
import Textarea from '../../../../pages/Textarea'
import CheckboxField from '../../../common/form/CheckboxField'
import {validateField} from '../../../../actions/helpers/validation'
import {
  fetchSkillVendorEditDataSuccess,
  validateSkillVendorEditField,
  submitSkillVendorEditFields,
  clearSkillVendorEditFields,
  clearSkillVendor} from '../../../../actions/pages/skillvendor-page'

class StatusBox extends Component {
  constructor(props){
    super(props);
    this.state={
      directorAccess: this.props.skillVendorDirectorAccess,
      doNotUse: this.props.donotuse,
      modal: false,
      className: 'modal-primary',
      size: 'md'

    }

    this.handleClick = this.handleClick.bind(this)
    this.toggle = this.toggle.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.openPopup = this.openPopup.bind(this)
  }


  toggle(){
    this.setState({
      modal: !this.state.modal
    })
  }

  handleClick(e){
    e.preventDefault();

    let access= '';
    if(this.state.directorAccess){
      if (window.confirm('Enable director app access?')){
        access = false;
        this.setState({directorAccess:access});
        let url='directors/changeDirectorAccess/'+this.props.skillVendorProfileId+'/'+access;
        this.props.ajax.put(url, null, null, () => {
        });
      }
    }else{
      if (window.confirm('Disable director app access?')){
        access = true;
        this.setState({directorAccess:access});
        let url='directors/changeDirectorAccess/'+this.props.skillVendorProfileId+'/'+access;
        this.props.ajax.put(url, null, null, () => {
        });
      }
    }
  }

  openPopup() {
    this.toggle();
    let url = 'skillvendors/' + this.props.skillVendorProfileId + '/edit';

    this.props.clearSkillVendorEditFields();
    this.setState({
      errorMsg: null
    })

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchSkillVendorEditDataSuccess(data);
    });
  }

  submitForm(){
    let validatedFields = this.props.fields.map(field => validateField(field))

    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true


    this.props.submitSkillVendorEditFields(validatedFields);

    if (!isValid){
      return;
    }


    let url = 'skillvendors/' + this.props.skillVendorProfileId + '/profiles/' + this.props.skillVendorProfileType.toLowerCase() +'/donotuse'
      let dataToSend = {}
    if(this.props.skillVendorProfileType == 'Director'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseDirector').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonDirector').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentDirector').value
      }
    }
    if(this.props.skillVendorProfileType == 'Adaptor'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseAdaptor').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonAdaptor').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentAdaptor').value
      }
    }
    if(this.props.skillVendorProfileType == 'Translator'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseTranslator').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonTranslator').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentTranslator').value
      }
    }
    if(this.props.skillVendorProfileType == 'Singer'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseSinger').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonSinger').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentSinger').value
      }
    }
    if(this.props.skillVendorProfileType == 'VoiceActor'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseActor').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonActor').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentActor').value
      }
    }
    if(this.props.skillVendorProfileType == 'Lyricist'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseLyricist').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonLyricist').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentLyricist').value
      }
    }
    if(this.props.skillVendorProfileType == 'Editor'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseEditor').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonEditor').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentEditor').value
      }
    }
    if(this.props.skillVendorProfileType == 'SoundEngineer'){
      dataToSend = {
        DoNotUse: this.props.fields.find(f => f.name === 'DoNotUseSoundEngineer').value,
        DoNotUseReason: this.props.fields.find(f => f.name === 'DoNotUseReasonSoundEngineer').value,
        DoNotUseComment: this.props.fields.find(f => f.name === 'DoNotUseCommentSoundEngineer').value
      }
    }
    if(!dataToSend.DoNotUse){
      dataToSend.DoNotUseReason = null;
      dataToSend.DoNotUseComment = null;
    }
    this.props.ajax.put(
      url,
      JSON.stringify(dataToSend),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if (response.status === 200) {
          this.setState({doNotUse:!this.state.doNotUse});
          this.toggle();
          this.props.notify(`The talent has been updated.`);
        }
        else{
          this.setState({
            errorMsg: `Can not update talent (id: ${this.props.skillVendorId})`
          })
        }
      })

  }

  render() {
      let fields = this.props.fields;
      let profileType = this.props.skillVendorProfileType;

    return (
      <>
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        wrapClassName={this.state.className}
        size={this.state.size}>
          <ModalHeader toggle={this.toggle}>Edit do not used</ModalHeader>
          <ModalBody>
          <EditForm
            title=""
            description="">
              <div style={{overflowY : "hidden",overflowX : "auto",whiteSpace: "nowrap", maxWidth:"600px", display:"flex",  scrollMargin: "20px"}}>
                <div className="col-10 mr-5" style={{marginLeft:"5%", displayInline:"block"}}>
                  {profileType == 'Director' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseDirector')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonDirector')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentDirector')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'Adaptor' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseAdaptor')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonAdaptor')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentAdaptor')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'Translator' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseTranslator')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonTranslator')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentTranslator')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'Singer' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseSinger')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonSinger')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentSinger')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'VoiceActor' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseActor')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonActor')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentActor')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'Lyricist' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseLyricist')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonLyricist')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentLyricist')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'Editor' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseEditor')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonEditor')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentEditor')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                  {profileType == 'SoundEngineer' &&
                  <>
                  <CheckboxField field={fields.find(f => f.name === 'DoNotUseSoundEngineer')} validate={this.props.validateSkillVendorEditField} />
                  <Select field={fields.find(f => f.name === 'DoNotUseReasonSoundEngineer')} validate={this.props.validateSkillVendorEditField} />
                  <Textarea field={fields.find(f => f.name === 'DoNotUseCommentSoundEngineer')} validate={this.props.validateSkillVendorEditField} rows="5" />
                  </>}

                </div>
              </div>


          </EditForm>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>Save</button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>Close</button>
          </ModalFooter>
        </Modal>
      <div className="col-md-6 widget">
        <div className="title">Status</div>
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="col-4">Status:</div>
              <div className="col-8">
                <StatusBadge status={this.props.status} statusLabel={this.props.statusLabel} />
              </div>
            </div>
            <div className="row">
              <div className="col-4">Status date:</div>
              <div className="col-8">{this.props.statusModifiedDate}</div>
            </div>
            {this.props.skillVendorProfileType == 'Director' &&
              <div className="row">
                <div className="col-4">Director app access:</div>
                <div className="col-8">
                  {!this.state.directorAccess? "Enabled ": "Disabled "}
                  <a href="#"
                   onClick={this.handleClick}>
                   <i style={{color: "black"}} className="material-icons">mode_edit</i></a>
                </div>
              </div>
            }
            <div className="row">
              <div className="col-4">Do not use:</div>
              <div className="col-8">
                {!this.state.doNotUse? "No ": "Yes "}
                <a href="#"
                 onClick={this.openPopup}>
                 <i style={{color: "black"}} className="material-icons">mode_edit</i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  status: state.skillVendorPage.currentProfile.Status.toLowerCase(),
  statusLabel: state.skillVendorPage.currentProfile.StatusLabel,
  statusModifiedDate: state.skillVendorPage.currentProfile.StatusModifiedDate,
  skillVendorProfileId: state.skillVendorPage.overview.Id,
  skillVendorDirectorAccess: state.skillVendorPage.currentProfile.DirectorAppAccessRevoked,
  skillVendorProfileType: state.skillVendorPage.currentProfile.ProfileType,
  skillVendor: state.skillVendorPage,
  doNotUse: state,
  fields: state.skillVendorEdit.fields

})
const mapDispatchToProps = dispatch => ({
  validateSkillVendorEditField: (value, field) => dispatch(validateSkillVendorEditField(value, field)),
  clearSkillVendorEditFields: () => dispatch(clearSkillVendorEditFields()),
  clearSkillVendor: () => dispatch(clearSkillVendor()),
  fetchSkillVendorEditDataSuccess: (editData) => dispatch(fetchSkillVendorEditDataSuccess(editData)),
  submitSkillVendorEditFields: fields => dispatch(submitSkillVendorEditFields(fields)),
  validateSkillVendorEditField: (value, field) => dispatch(validateSkillVendorEditField(value, field)),
  clearSkillVendorEditFields: () => dispatch(clearSkillVendorEditFields()),
  clearSkillVendor: () => dispatch(clearSkillVendor())
})
//export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(StatusBox))

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(StatusBox)
